import { Platform } from "react-native";

/**
 * Returns the auth callback URL for magic link and OAuth redirects.
 * - Web: uses `window.location.origin` so it works on any host/port
 * - Native: uses the expo-moon deep-link scheme
 */
export function getAuthCallbackUrl(): string {
  return Platform.OS === "web"
    ? `${window.location.origin}/auth/callback`
    : "mylouise://auth/callback";
}

/**
 * Save current URL so auth callback can redirect back after login.
 * Uses sessionStorage (survives same-tab redirects like OAuth).
 */
export function saveAuthReturnUrl(): void {
  if (Platform.OS !== "web") return;
  const returnTo = window.location.pathname + window.location.search;
  if (returnTo && returnTo !== "/") {
    sessionStorage.setItem("auth_return_url", returnTo);
  }
}

/**
 * Consume the stored return URL (one-time read).
 */
export function consumeAuthReturnUrl(): string | null {
  if (Platform.OS !== "web") return null;
  const url = sessionStorage.getItem("auth_return_url");
  if (url) sessionStorage.removeItem("auth_return_url");
  return url;
}
